import React, { ReactElement } from 'react';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useIntl } from 'react-intl';

interface IOverlayTooltipProps {
  children: ReactElement;
  message: string;
}

const OverlayTooltip = ({ message, children }: IOverlayTooltipProps) => {
  const { formatMessage } = useIntl();
  return (
    <OverlayTrigger overlay={<Tooltip id="tooltip-info">{formatMessage({ id: message })}</Tooltip>}>
      {children}
    </OverlayTrigger>
  );
};

export default OverlayTooltip;
